module.exports = __webpack_public_path__ + "img/sos-bag.758abcde.png";